import { render } from "./products.vue?vue&type=template&id=7f226694&scoped=true&ts=true"
import script from "./products.vue?vue&type=script&lang=ts"
export * from "./products.vue?vue&type=script&lang=ts"

import "./products.vue?vue&type=style&index=0&id=7f226694&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f226694"]])

export default __exports__